"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.sort");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _data = require("@/api/data");

var _index = require("@/utils/index");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  data: function data() {
    return {
      // 表格数据
      data: [],
      // 排序规则，默认 id 降序， 支持多字段排序 ['id,desc', 'createTime,asc']
      sort: ['id,desc'],
      // 页码
      page: 0,
      // 每页数据条数
      size: 10,
      // 总数据条数
      total: 0,
      // 请求数据的url
      url: '',
      // 查询数据的参数
      params: {},
      // 待查询的对象
      query: {},
      // 等待时间
      time: 50,
      // 是否为新增类型的表单
      isAdd: false,
      // 导出的 Loading
      downloadLoading: false,
      // 表格 Loading 属性
      loading: true,
      // 删除 Loading 属性
      delLoading: false,
      delAllLoading: false,
      // 弹窗属性
      dialog: false,
      // Form 表单
      form: {},
      // 重置表单
      resetForm: {},
      // 标题
      title: ''
    };
  },
  methods: {
    parseTime: _index.parseTime,
    downloadFile: _index.downloadFile,
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.beforeInit();

              case 2:
                if (_context.sent) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _this.loading = true; // 请求数据

                  // 请求数据
                  (0, _data.initData)(_this.url, _this.getQueryParame()).then(function (data) {
                    _this.total = data.totalElements;
                    _this.data = data.content; // time 毫秒后显示表格

                    // time 毫秒后显示表格
                    setTimeout(function () {
                      _this.loading = false;
                    }, _this.time);
                    resolve(data);
                  }).catch(function (err) {
                    _this.loading = false;
                    reject(err);
                  });
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    beforeInit: function beforeInit() {
      return true;
    },
    getQueryParame: function getQueryParame() {
      return _objectSpread(_objectSpread({
        page: this.page,
        size: this.size,
        sort: this.sort
      }, this.query), this.params);
    },
    // 改变页码
    pageChange: function pageChange(e) {
      this.page = e - 1;
      this.init();
    },
    // 改变每页显示数
    sizeChange: function sizeChange(e) {
      this.page = 0;
      this.size = e;
      this.init();
    },
    // 预防删除第二页最后一条数据时，或者多选删除第二页的数据时，页码错误导致请求无数据
    dleChangePage: function dleChangePage(size) {
      if (size === undefined) {
        size = 1;
      }

      if (this.data.length === size && this.page !== 0) {
        this.page = this.page - 1;
      }
    },
    // 查询方法
    toQuery: function toQuery() {
      this.page = 0;
      this.init();
    },

    /**
     * 通用的提示封装
     */
    submitSuccessNotify: function submitSuccessNotify() {
      this.$notify({
        title: '提交成功',
        type: 'success',
        duration: 2500
      });
    },
    addSuccessNotify: function addSuccessNotify() {
      this.$notify({
        title: '新增成功',
        type: 'success',
        duration: 2500
      });
    },
    editSuccessNotify: function editSuccessNotify() {
      this.$notify({
        title: '编辑成功',
        type: 'success',
        duration: 2500
      });
    },
    delSuccessNotify: function delSuccessNotify() {
      this.$notify({
        title: '删除成功',
        type: 'success',
        duration: 2500
      });
    },
    notify: function notify(title, type) {
      this.$notify({
        title: title,
        type: type,
        duration: 2500
      });
    },

    /**
     * 删除前可以调用 beforeDelMethod 做一些操作
     */
    beforeDelMethod: function beforeDelMethod() {
      return true;
    },

    /**
     * 通用的删除
     */
    delMethod: function delMethod(id) {
      var _this2 = this;

      if (!this.beforeDelMethod()) {
        return;
      }

      this.delLoading = true;
      this.crudMethod.del(id).then(function () {
        _this2.delLoading = false;

        _this2.$refs[id].doClose();

        _this2.dleChangePage();

        _this2.delSuccessNotify();

        _this2.afterDelMethod();

        _this2.init();
      }).catch(function () {
        _this2.delLoading = false;

        _this2.$refs[id].doClose();
      });
    },
    afterDelMethod: function afterDelMethod() {},

    /**
     * 多选删除提示
     */
    beforeDelAllMethod: function beforeDelAllMethod() {
      var _this3 = this;

      this.$confirm('你确定删除选中的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.delAllMethod();
      });
    },

    /**
     * 多选删除
     */
    delAllMethod: function delAllMethod() {
      var _this4 = this;

      this.delAllLoading = true;
      var data = this.$refs.table.selection;
      var ids = [];

      for (var i = 0; i < data.length; i++) {
        ids.push(data[i].id);
      }

      this.crudMethod.delAll(ids).then(function () {
        _this4.delAllLoading = false;

        _this4.dleChangePage(ids.length);

        _this4.init();

        _this4.$notify({
          title: '删除成功',
          type: 'success',
          duration: 2500
        });
      }).catch(function () {
        _this4.delAllLoading = false;
      });
    },

    /**
     * 显示新增弹窗前可以调用该方法
     */
    beforeShowAddForm: function beforeShowAddForm() {},

    /**
     * 显示新增弹窗
     */
    showAddFormDialog: function showAddFormDialog() {
      this.isAdd = true;
      this.resetForm = JSON.parse(JSON.stringify(this.form));
      this.beforeShowAddForm();
      this.dialog = true;
    },

    /**
     * 显示编辑弹窗前可以调用该方法
     */
    beforeShowEditForm: function beforeShowEditForm(data) {},

    /**
     * 显示编辑弹窗
     */
    showEditFormDialog: function showEditFormDialog() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.isAdd = false;

      if (data) {
        this.resetForm = JSON.parse(JSON.stringify(this.form));
        this.form = JSON.parse(JSON.stringify(data));
      }

      this.beforeShowEditForm(data);
      this.dialog = true;
    },

    /**
     * 新增方法
     */
    addMethod: function addMethod() {
      var _this5 = this;

      this.crudMethod.add(this.form).then(function () {
        _this5.addSuccessNotify();

        _this5.loading = false;

        _this5.afterAddMethod();

        _this5.cancel();

        _this5.init();
      }).catch(function () {
        _this5.loading = false;

        _this5.afterAddErrorMethod();
      });
    },

    /**
     * 新增后可以调用该方法
     */
    afterAddMethod: function afterAddMethod() {},

    /**
     * 新增失败后调用该方法
     */
    afterAddErrorMethod: function afterAddErrorMethod() {},

    /**
     * 通用的编辑方法
     */
    editMethod: function editMethod() {
      var _this6 = this;

      this.crudMethod.edit(this.form).then(function () {
        _this6.editSuccessNotify();

        _this6.loading = false;

        _this6.afterEditMethod();

        _this6.cancel();

        _this6.init();
      }).catch(function () {
        _this6.loading = false;
      });
    },

    /**
     * 编辑后可以调用该方法
     */
    afterEditMethod: function afterEditMethod() {},

    /**
     * 提交前可以调用该方法
     */
    beforeSubmitMethod: function beforeSubmitMethod() {
      return true;
    },

    /**
     * 提交
     */
    submitMethod: function submitMethod() {
      var _this7 = this;

      if (!this.beforeSubmitMethod()) {
        return;
      }

      if (this.$refs['form']) {
        this.$refs['form'].validate(function (valid) {
          if (valid) {
            _this7.loading = true;

            if (_this7.isAdd) {
              _this7.addMethod();
            } else _this7.editMethod();
          }
        });
      }
    },

    /**
     * 隐藏弹窗
     */
    cancel: function cancel() {
      this.dialog = false;

      if (this.$refs['form']) {
        this.$refs['form'].clearValidate();
        this.form = this.resetForm;
      }
    },

    /**
     * 获取弹窗的标题
     */
    getFormTitle: function getFormTitle() {
      return this.isAdd ? "\u65B0\u589E".concat(this.title) : "\u7F16\u8F91".concat(this.title);
    },

    /**
     * 通用导出
     */
    downloadMethod: function downloadMethod() {
      var _this8 = this;

      this.beforeInit();
      this.downloadLoading = true;
      (0, _data.download)(this.url + '/download', this.params).then(function (result) {
        _this8.downloadFile(result, _this8.title + '数据', 'xlsx');

        _this8.downloadLoading = false;
      }).catch(function () {
        _this8.downloadLoading = false;
      });
    }
  }
};
exports.default = _default;